import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Usef_person } from '../models/usef/usef_person';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class UsefPersonSearchService {

  constructor(private http: HttpClient) { }

getById(search_id_term: string, entity_type: string): Promise<Usef_person[]> {
	return this.getListWithRest("member_id/" + search_id_term + "/entity_type/" + entity_type);
}

getByName(first_name: string, last_name: string, city: string, state: string): Promise<Usef_person[]> {
	let rest_fragment: string =  "last_name/" + encodeURIComponent(last_name);

	if(first_name != ''){
		rest_fragment += "/first_name/" + encodeURIComponent(first_name);
	}

	if(city != ''){
		rest_fragment += "/city/" + encodeURIComponent(city);
	}

	if(state != ''){
		rest_fragment += "/state/" + encodeURIComponent(state);
	}

	return this.getListWithRest( rest_fragment );
}

getByEntityName(entity_name: string): Promise<Usef_person[]> {
	return this.getListWithRest("entity_name/" + encodeURIComponent(entity_name));
}

private getListWithRest(rest_url: string) : Promise<Usef_person[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'usef_search/' + rest_url).subscribe((response:any) => {
			if(response && response.type && response.type == 'usef_people' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		} else {
	      			reject(error_response.data ? error_response.data : error_response);
	      		}
			});
	});
  }




}


